import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class IosDataSetupModalContext {
    public network: string;
}

@Component({
    selector: 'ios-data-setup-modal',
    templateUrl: './ios-data-setup-modal.component.html',
    styleUrls: ['./ios-data-setup-modal.component.scss']
})
export class IosDataSetupModalComponent {
    public context: any;
    public activeStep: number = 1;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialogRef<IosDataSetupModalContext>) {
        this.context = data;
    }

    next() {
        if (this.activeStep >= 9) {
            return;
        }
        ++this.activeStep;
    }

    back() {
        if (this.activeStep == 0)
            return;
        --this.activeStep;
    }

    beforeClose(): boolean {
        if (document.body.classList.contains('modal-open')) {
            document.body.classList.remove('modal-open');
        }
        return false;
    }
    beforeDismiss(): boolean {
        return this.beforeClose();
    }

    closeDialog(res?): void {
        this.beforeDismiss();
        this.dialog.close(res);
    }
}